/*!
 * datepicker: a port of the calendar module from https://material.angularjs.org
 * Copyright(c) 2016 Google
 * MIT Licensed
 */

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";

import { DatepickerComponent } from "./datepicker.component";

export * from "./datepicker.component";

@NgModule({
  declarations: [DatepickerComponent],
  exports: [DatepickerComponent],
  imports: [CommonModule, FormsModule],
})
export class DatepickerModule {}
